import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { HiOutlineHome, HiOutlineDocumentText, HiOutlineUser } from "react-icons/hi";
import "../styles/BottomNav.css";

const tabs = [
  { path: "/dashboard", icon: HiOutlineHome, label: "Início" },
  { path: "/documents", icon: HiOutlineDocumentText, label: "Documentos" },
  { path: "/profile", icon: HiOutlineUser, label: "Perfil" },
];

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav className="bottomNav" aria-label="Navegação principal">
      {tabs.map((tab) => {
        const isActive = location.pathname === tab.path ||
          (tab.path === "/dashboard" && location.pathname === "/");
        const Icon = tab.icon;
        return (
          <button
            key={tab.path}
            type="button"
            className={`bottomNav-tab ${isActive ? "bottomNav-tab--active" : ""}`}
            onClick={() => navigate(tab.path)}
            aria-current={isActive ? "page" : undefined}
          >
            <Icon className="bottomNav-icon" />
            <span className="bottomNav-label">{tab.label}</span>
            {isActive && <span className="bottomNav-indicator" />}
          </button>
        );
      })}
    </nav>
  );
};

export default BottomNav;
